import React from "react";
import ct from "class-types.macro";
import Carousel, { Item } from "../common/Carousel";
import { CategoryEnhancedGridSectionResult } from "~/common/Store/models/Category";
import { Image } from "@wss/image";

interface Props {
  brandSection: CategoryEnhancedGridSectionResult[];
}

const BrandCarousel = ({ brandSection }: Props) => {
  return (
    <Carousel>
      {brandSection.map((brand) => (
        <Item sliderRight key={brand.link}>
          <>
            <div
              className={ct(
                "border-transparent",
                "group-hover:border-gray-200",
                "border-solid",
                "border",
                "p-1",
              )}
            >
              <a href={brand.link} title={brand.description}>
                <Image
                  alt={brand.description}
                  src={brand.imagePath}
                  width={1}
                  height={1}
                  className="category_image h-full w-full block"
                  data-src={brand.imagePath}
                />
              </a>
            </div>
            <div className={ct("mt-2", "max-w-xs", "text-center")}>
              <a
                className={ct("font-semibold", "text-sm-1/2", "break-words")}
                title={brand.description}
                href={brand.link}
              >
                {brand.description}
              </a>
            </div>
          </>
        </Item>
      ))}
    </Carousel>
  );
};

export default BrandCarousel;
